import { useCallback } from "react";
import { IdentificationInputValue } from "../IdentificationInput.types";
import { useControlled } from "@commonlibs";
import useTranslate from "ui/locale/hooks/useTranslate";

export interface UseIdentificationInputParams {
    required?: boolean;
    defaultValue: IdentificationInputValue;
    value?: IdentificationInputValue;
    onChange?: (value: IdentificationInputValue) => void;
}

export default function useIdentificationInput({ required = false, defaultValue, value, onChange }: UseIdentificationInputParams) {
    const translate = useTranslate();

    const [inputCode, setInputCode] = useControlled(defaultValue, value, onChange);

    const validation = useCallback(
        (idenValue: IdentificationInputValue): [boolean, string | undefined] => {
            if (idenValue[1] === "") return [!required, translate("invalid_required", { ns: "error" })];
            else return [true, undefined];
        },
        [required],
    );

    return { validation, inputCode, setInputCode, hideError: required && inputCode[1] === "" };
}
